import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { RewardsPage } from "../../features/rewards/pages/rewards-page";

export const Route = createFileRoute("/_layout/rewards")({
  component: RewardsLayout,
});

function RewardsLayout() {
  const location = useLocation();

  // Check if we're on main rewards tab routes or unstake paths
  const isMainRewardsPath =
    /^\/rewards\/(positions|idle|activity)$/.test(location.pathname) ||
    location.pathname === "/rewards";
  const isUnstakePath = /^\/rewards\/[^/]+\/unstake\/[^/]+$/.test(location.pathname);

  // Render RewardsPage layout for main tab routes and unstake paths
  // Otherwise render child routes (like /rewards/eth for EarnPage)
  return isMainRewardsPath || isUnstakePath ? <RewardsPage /> : <Outlet />;
}
